import Controller from './controller'
import { scrollToPosition } from '../utilities'

export default class extends Controller {
  static targets = ['link', 'section']

  initialize() {
    this.activeClass = 'is-active'
    this.onIntersect = this.onIntersect.bind(this)

    this.observer = new IntersectionObserver(this.onIntersect, {
      rootMargin: '-10% 0px -60% 0px',
      threshold: 0,
    })

    this.sectionTargets.forEach((section) => this.observer.observe(section))

    if (this.linkTargets.length) {
      this.setActive(0)
    }
  }

  disconnect() {
    this.observer?.disconnect()
  }

  onIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const index = this.sectionTargets.indexOf(entry.target)

        if (index >= 0) {
          this.setActive(index)
        }
      }
    })
  }

  click(ev) {
    ev.preventDefault()

    const link = ev.currentTarget.closest('[data-choose-nursery-target="link"]')
    const index = this.linkTargets.indexOf(link)
    const section = this.sectionTargets[index]

    if (!section) {
      return
    }

    const navEl = document.getElementById('navigation')

    scrollToPosition({
      top: window.pageYOffset + section.getBoundingClientRect().top - navEl.offsetHeight,
      includeHeaderOffset: false,
    })

    this.setActive(index)
    this.closeNavDropdown()
  }

  setActive(index) {
    this.linkTargets.forEach((link) => link.classList.remove(this.activeClass))
    this.linkTargets[index]?.classList.add(this.activeClass)
  }

  closeNavDropdown() {
    const nav = this.element.querySelector('.choose-nursery__nav')

    if (!nav) {
      return
    }

    const dropdown = this.application.getControllerForElementAndIdentifier(nav, 'dropdown')

    dropdown?.close()
  }
}
